import { baseApi } from '@/services/api';
import { Pricing} from './pricingTypes';

export const pricingAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Pricing
    getPricings: builder.query<Pricing, { status?: string }>({
      query: (params) => ({
        url: '/products',
        method: 'GET',
        params,
      }),
      providesTags: ['Pricing'],
    }),

    getPricing: builder.query<Pricing, string>({
      query: (id) => ({
        url: `/pricing/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Pricing', id }],
    }),

    createPricing: builder.mutation<Pricing, Partial<Pricing>>({
      query: (Pricing) => ({
        url: '/pricing',
        method: 'POST',
        data: Pricing,
      }),
      invalidatesTags: ['Pricing'],
    }),

    updatePricing: builder.mutation<Pricing, { id: string; data: Partial<Pricing> }>({
      query: ({ id, data }) => ({
        url: `/pricing/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Pricing', id }, 'Pricing'],
    }),

    deletePricing: builder.mutation<void, string>({
      query: (id) => ({
        url: `/pricing/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Pricing'],
    }),

    
   
  }),
});

export const {
  useGetPricingsQuery,
  useLazyGetPricingsQuery,
  useGetPricingQuery,
  useCreatePricingMutation,
  useUpdatePricingMutation,
  useDeletePricingMutation,
 
} = pricingAPI;
